import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuIcon, CloseIcon } from "./icons";

export default function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-4 right-4 z-50 p-2 rounded-lg bg-white shadow-lg border border-gray-200"
        aria-label="Toggle menu"
        aria-expanded={isOpen}
        aria-controls="main-menu"
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Menu Panel */}
      <div
        id="main-menu"
        inert={isOpen ? undefined : ""}
        aria-hidden={!isOpen}
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl z-40 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <nav className="flex flex-col p-8 pt-20 space-y-6">
          <button
            onClick={() => handleNavigate("/")}
            className="text-left text-lg font-medium text-gray-900 hover:text-orange-600 transition-colors"
          >
            Your Next Chapter
          </button>
          <button
            onClick={() => handleNavigate("/name")}
            className="text-left text-lg font-medium text-gray-900 hover:text-orange-600 transition-colors"
          >
            Get my free preview
          </button>
          <button
            onClick={() => handleNavigate("/privacy")}
            className="text-left text-lg font-medium text-gray-900 hover:text-orange-600 transition-colors"
          >
            Privacy Policy
          </button>
          <button
            onClick={() => handleNavigate("/terms")}
            className="text-left text-lg font-medium text-gray-900 hover:text-orange-600 transition-colors"
          >
            Terms of Use
          </button>
          
          <div className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              AYUPATH
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Your Vedic dasha timeline
            </p>
          </div>
        </nav>
      </div>
    </>
  );
}
